<template>
  <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
    <div class="row">
      <div class="col-md-12" align="right" v-if="isAdmin">
        <router-link to="/create_user">
          <base-button type="primary">New User</base-button>
        </router-link>
      </div>
       <div class="col-md-12 mt-4 mb-4" v-if="isAdmin">
        <editor-info-table />
      </div>
      <div class="col-md-12 mt-4 mb-4" v-if="isAdmin">
        <streamer-info-table />
      </div>
      <div class="col-md-12 mt-4 mb-4" v-if="isAdmin">
        <user-info-table status="active" />
      </div>
       <div class="col-md-12 mt-4 mb-4">
        <user-info-table status="disabled" />
      </div>
    </div>
  </div>
</template>

<script>
import StreamerInfoTable from '@/views/UserManagement/StreamerInfoTable'
import UserInfoTable from '@/views/UserManagement/UserInfoTable'
import EditorInfoTable from '@/views/UserManagement/EditorInfoTable'

import { mapGetters } from 'vuex'

export default {
  components: { StreamerInfoTable, UserInfoTable, EditorInfoTable },
  computed: {
    ...mapGetters({
      isAdmin: 'isAdmin'
    })
  }
}
</script>

<style>
</style>
